import React from "react";
import LegalPage, { DocSections } from "@/pages/legal/LegalPage";
import { TERMS } from "@/pages/legal/_content";

const Terms = () => <LegalPage doc={TERMS}><DocSections sections={TERMS.sections}/></LegalPage>;
export default Terms;
